const CONST_PAGE = require("../../definition/page.json");
module.exports = Object.freeze({
  //共通（100番台）
  // 画面ID ログイン
  LOGIN: CONST_PAGE.find(page => page.label === "ログイン").value,
  // 画面ID トップページ
  TOPPAGE: CONST_PAGE.find(page => page.label === "トップページ").value,
  //業務（200番台）
  // 画面ID 経歴一覧
  CAREERS: CONST_PAGE.find(page => page.label === "経歴一覧").value, 
  // 画面ID 経歴表示・編集
  CAREER_EDITING: CONST_PAGE.find(page => page.label === "経歴表示・編集").value,
  //マスタ（900番台）
  // 画面ID ユーザー一覧
  USER_MASTER: CONST_PAGE.find(page => page.label === "ユーザー一覧").value,
  // 画面ID ユーザー表示・編集
  USER_EDIT_MASTER: CONST_PAGE.find(page => page.label === "ユーザー表示・編集").value,
  // 画面ID 組織マスタ一覧
  ORGANIZATION_MASTER: CONST_PAGE.find(page => page.label === "組織マスタ一覧").value, 
  // 画面ID 組織マスタ表示・編集
  ORGANIZATION_EDIT_MASTER: CONST_PAGE.find(page => page.label === "組織マスタ表示・編集").value,
  // 画面ID 役職マスタ一覧
  POSITION_MASTER: CONST_PAGE.find(page => page.label === "役職マスタ一覧").value,
  // 画面ID 役職マスタ表示・編集
  POSITION_EDIT_MASTER: CONST_PAGE.find(page => page.label === "役職マスタ表示・編集").value,
  // 画面ID 閲覧権限マスタ一覧
  AUTHORITY_MASTER: CONST_PAGE.find(page => page.label === "閲覧権限マスタ一覧").value, 
  // 画面ID 閲覧権限マスタ表示・編集
  AUTHORITY_EDIT_MASTER: CONST_PAGE.find(page => page.label === "閲覧権限マスタ表示・編集").value,
  // 画面ID スキルマスタ一覧
  SKILL_MASTER: CONST_PAGE.find(page => page.label === "スキルマスタ一覧").value,
  // 画面ID スキルマスタ表示・編集
  SKILL_EDIT_MASTER: CONST_PAGE.find(page => page.label === "スキルマスタ表示・編集").value,
  // 画面ID 資格マスタ一覧
  QUALIFICATION_MASTER: CONST_PAGE.find(page => page.label === "資格マスタ一覧").value,
  // 画面ID 資格マスタ表示・編集
  QUALIFICATION_EDIT_MASTER: CONST_PAGE.find(page => page.label === "資格マスタ表示・編集").value,
  // 画面ID 個人資格情報一覧
  QUALIFICATIONINFO: CONST_PAGE.find(page => page.label === "個人資格情報一覧").value,
  // 画面ID 個人資格情報表示・編集
  QUALIFICATIONINFO_EDIT: CONST_PAGE.find(page => page.label === "個人資格情報表示・編集").value,
  // 画面ID 個人スキル情報一覧
  SKILLINFO: CONST_PAGE.find(page => page.label === "個人スキル情報一覧").value,
  // 画面ID 個人スキル情報表示・編集
  SKILLINFO_EDIT: CONST_PAGE.find(page => page.label === "個人スキル情報表示・編集").value,
});